const simpleSkillFields = ["skills", "projects", "courses", "languages"];
const complexSkillFields = ["educations", "awards", "certifications", "volunteering_experiences", "publications", "patents"];

export const skillFields = simpleSkillFields.concat(complexSkillFields);
